"use strict";

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("complianceGroups", {
    template: require("./complianceGroups.html"),
    controller: ComplianceGroupsController
  });

  ComplianceGroupsController.$inject = ["$scope", "$state", "$q", "GroupsService", "$rootScope", "$location", "$stateParams", "cacheService"];

  function ComplianceGroupsController($scope, $state, $q, GroupsService, $rootScope, $location, $stateParams, cacheService) {
    var vm = this;
    //Check for query string parameters. Redirect if so
    var search = $location.search();
    var isQueryString = !!search.vehicleGroupName || !!search.driverGroupName || !!search.driverId || !!search.vehicleId || !!search.tripId;
    if (isQueryString) {
      $rootScope.$broadcast("DisableAddCenterParam");
      $rootScope.$broadcast("hideCompliance");
      $state.go("main.compliance.querystring", {
        "queryUrl": search
      }, {
        location: false,
        notify: false
      });
      return;
    }

    vm.$onInit = init;

    vm.goToGroup = goToGroup;
    vm.loadMoreItems = loadMoreItems;
    vm.filterItems = filterItems;
    vm.onGroupTypeChange = onGroupTypeChange;

    function init() {
      // Properties
      vm.panelWidth = "500px";
      vm.isLoading = false;
      vm.selectedGroupType = $stateParams.group ? $stateParams.group : cacheService.getCache().selectedGroupType; //$stateParam is defined if coming from a group state
      vm.filterGroup = vm.selectedGroupType === "vehicleGroup" ? cacheService.getCache().vehicleGroupFilter : cacheService.getCache().driverGroupFilter;
      vm.allItems = [];
      vm.filteredItems = [];
      vm.shownItems = [];
      vm.isLoading = true;
      vm.hideQuestionable = true;

      // load vehicle and driver groups once and keep them in memory. This may need to be reworked depending on the user interaction.
      $q.all([_loadDriverGroups(), _loadVehicleGroups()]).finally(function () {
        return vm.isLoading = false;
      });

      $scope.$watch(function () {
        return vm.selectedGroupType;
      }, function (newValue, oldValue) {
        return _selectedGroupTypeChanged(newValue, oldValue);
      });
    }

    function goToGroup(groupType, groupId) {
      $state.go($stateParams.childState, {
        "groupType": groupType,
        "groupId": groupId
      });
    }

    function onGroupTypeChange() {
      cacheService.getCache().selectedGroupType = vm.selectedGroupType;
      cacheService.saveCache();
    }

    function filterItems(filter) {
      // whenever filtering the list of units, reset the selected items
      if (!filter) {
        vm.filteredItems = vm.allItems;
      } else if (vm.selectedGroupType === "driverGroup" || vm.selectedGroupType === "vehicleGroup") {
        var filterUpperCase = filter.toUpperCase();
        vm.filteredItems = vm.allItems.filter(function (g) {
          return g.groupName != null && g.groupName.toUpperCase().indexOf(filterUpperCase) != -1;
        });
      } else {
        var _filterUpperCase = filter.toUpperCase();
        vm.filteredItems = vm.allItems.filter(function (c) {
          return c.name != null && c.name.toUpperCase().indexOf(_filterUpperCase) != -1;
        });
      }
      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
      vm.shownItems = vm.filteredItems.slice(0, 40);
      $scope.$emit("list:filtered");

      if (vm.selectedGroupType === "vehicleGroup") {
        cacheService.getCache().vehicleGroupFilter = filter;
      } else {
        cacheService.getCache().driverGroupFilter = filter;
      }
      cacheService.saveCache();
    }

    function onFilterKeyUp(event) {
      if (event.keyCode === 27) {
        vm.filterGroup = null;
        vm.filterItems(vm.filterGroup);
      }
    }

    function loadMoreItems() {
      console.log("showing more items: " + vm.shownItems.length + ":" + (vm.shownItems.length + 10));
      var newItems = vm.filteredItems.slice(vm.shownItems.length, vm.shownItems.length + 10);
      vm.shownItems = vm.shownItems.concat(newItems);
    }

    function _loadDriverGroups() {
      var forceRefresh = true;
      return GroupsService.getDriverGroups(forceRefresh).then(function (groups) {
        vm.driverGroups = groups.map(function (c) {
          return {
            groupId: c.id,
            groupName: c.name,
            numItems: c.numberOfDrivers
          };
        });

        // after loading driver groups, if this is what tab is currently selected, show the results
        if (vm.selectedGroupType === "driverGroup") {
          vm.allItems = vm.driverGroups;
          filterItems(vm.filterGroup);
        }
      });
    }

    function _loadVehicleGroups() {
      var forceRefresh = true;
      return GroupsService.getVehicleGroups(forceRefresh).then(function (groups) {
        vm.vehicleGroups = groups.map(function (c) {
          return {
            groupId: c.id,
            groupName: c.name,
            numItems: c.numberOfVehicles
          };
        });

        // after loading vehicle groups, if this is what tab is currently selected, show the results
        if (vm.selectedGroupType === "vehicleGroup") {
          vm.allItems = vm.vehicleGroups;
          filterItems(vm.filterGroup);
        }
      });
    }

    function _selectedGroupTypeChanged(newValue, oldValue) {
      // whenever the tab between vehicle and driver groups changes, set those as the current groups
      if (newValue === "vehicleGroup") {
        vm.allItems = vm.vehicleGroups || [];
      } else {
        vm.allItems = vm.driverGroups || [];
      }

      var element = document.getElementById("groupsList");
      if (element) {
        element.scrollTop = 0;
      }

      if (newValue === "vehicleGroup") {
        vm.filterGroup = cacheService.getCache().vehicleGroupFilter;
      } else {
        vm.filterGroup = cacheService.getCache().driverGroupFilter;
      }
      filterItems(vm.filterGroup);
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/compliance/complianceGroups.controller.js